module.exports = __webpack_public_path__ + "b44e1285abee3c63c91809bedee1dcd8.svg";